import {setSmsNumber} from 'src/pages/reportIssue/store/actions/creators';
import {loadSmsEnrollment, LOAD_SMS_ENROLLMENT_COMPLETE} from 'src/shared/smsEnrollment/actions';
import {createReportIssueTimestamp, CREATE_REPORT_ISSUE_TIMESTAMP_COMPLETE} from 'src/shared/reportIssue/actions';
import {waitUntil} from 'src/shared/events';
import {succesfullyEnrolled} from 'src/shared/smsEnrollment/selectors';
import {changeView} from 'src/shared/currentView/actions';
import {SMS_ENROLLED, ERROR_SCREEN} from 'src/pages/reportIssue/constants/views';

export const enrollSms = mobileNumber => async (dispatch, getState) => {
  dispatch(setSmsNumber(mobileNumber));
  dispatch(loadSmsEnrollment(mobileNumber));
  dispatch(createReportIssueTimestamp());
  await waitUntil(LOAD_SMS_ENROLLMENT_COMPLETE, CREATE_REPORT_ISSUE_TIMESTAMP_COMPLETE);
  if (succesfullyEnrolled(getState())) {
    return dispatch(changeView(SMS_ENROLLED));
  }
  return dispatch(changeView(ERROR_SCREEN));
};
